/**
 * King Living Routes
 *
 * Extends the base retail app routes with custom King Living routes.
 */

import loadable from '@loadable/component';

import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config';
import {Skeleton} from '@salesforce/retail-react-app/app/components/shared/ui';
import {routes as baseRoutes} from '@salesforce/retail-react-app/app/routes';
import {configureRoutes} from '@salesforce/retail-react-app/app/utils/routes-utils';

const fallback = <Skeleton height="75vh" width="100%" />;
const ExamplesPage = loadable(() => import('./pages/examples'), {fallback});

// NOTE: the former `/page/:slug` route (→ `@amblique/contentful/app/pages/page`) was
// removed — it was shadowed by the `king-living` catch-all `DynamicPage` (which resolves
// Contentful pages by slug) and never matched. See docs/contentful/preview/README.md §10.
export const routes = [
  {
    path: '/examples',
    component: ExamplesPage,
    exact: true,
  },
  ...baseRoutes
];

export default () => {
  const config = getConfig();

  return configureRoutes(routes, config, {
    ignoredRoutes: ['/callback', '*'],
  });
};
